var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteStarsLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336 172"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "quote-stars-left_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "quote-stars-left_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435E83",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "quote-stars-left_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3E55",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80AFE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "quote-stars-left_svg__b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "quote-stars-left_svg__d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#quote-stars-left_svg__a)",
    opacity: 0.651,
    x: 24,
    width: 317,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 82.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0E1932",
    filter: "url(#quote-stars-left_svg__b)",
    x: 225,
    y: 0.897,
    width: 109,
    height: 52,
    rx: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 .897c14.36 0 26 11.64 26 26s-11.64 26-26 26h-57c-14.36 0-26-11.64-26-26s11.64-26 26-26h57zm0 3h-57c-12.703 0-23 10.297-23 23 0 12.575 10.093 22.794 22.62 22.997l.38.003h57c12.703 0 23-10.298 23-23C331 14.32 320.907 4.103 308.38 3.9l-.38-.003z",
    fill: "#3C5475",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#quote-stars-left_svg__c)",
    opacity: 0.556,
    y: 11.897,
    width: 309,
    height: 29,
    rx: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    filter: "url(#quote-stars-left_svg__d)",
    cx: 295,
    cy: 26.897,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#quote-stars-left_svg__e)",
    opacity: 0.752,
    x: 68,
    y: 165,
    width: 165,
    height: 7,
    rx: 3.5
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgQuoteStarsLeft as ReactComponent };